/* eslint-disable no-console */
import React from "react";

import PageHeading from "2g-page-heading";
import { useToggler } from "2g-hooks";
import Buttons from "2g-buttons";
import Form from "2g-form";

import { Prilohy, ImageChooser, FileChooser } from "b2b/components/prilohy";

const files = [
  { name: "Testovaci soubor", key: "prd" },
  { name: "Jak spravne programovat", key: "prd2" },
  { name: "StyleGuide pro B2B portal", key: "prd3" }
];

export function PrilohyExample() {
  const [disabled, toggleDisabled] = useToggler();
  return (
    <>
      <PageHeading>Prilohy</PageHeading>
      <Buttons.Primary onClick={toggleDisabled}>
        {disabled ? "Enabled" : "Disabled"}
      </Buttons.Primary>
      <div data-testid="Prilohy">
        <Prilohy
          files={files}
          disabled={disabled}
          onDownload={file => {
            console.log("DOWNLOAD", file.name);
          }}
          onDelete={file => {
            console.log("DELETE", file.name);
          }}
        />
      </div>
      <PageHeading>ImageChooser</PageHeading>
      <div data-testid="ImageChooser">
        <Form moduleKey="components.imageChooser">
          <ImageChooser path="obrazek" />
        </Form>
      </div>
      <PageHeading>FileChooser</PageHeading>
      <div data-testid="FileChooser">
        <Form moduleKey="components.fileChooser">
          <FileChooser path="obrazek" hasDelete hasDownload />
        </Form>
      </div>
    </>
  );
}

export default React.memo(PrilohyExample);
